module.exports = {"deleteButton":"Guardian löschen","addGuardianButton":"Guardian erfassen +","meta":"Meine Guardians"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/guardians.json
// module id = K6D0
// module chunks = 1